module.exports = __webpack_public_path__ + "img/gear.8cb5a06b.svg";